import type { FirmRole } from "@contract/firm/me";
import {
  inviteResponseSchema,
  membersResponseSchema,
  type InviteOutcome,
  type MembersResponse,
} from "@contract/firm/members";
import { apiRequest } from "./client";

export function fetchMembers(): Promise<MembersResponse> {
  return apiRequest("/v1/firm/members", {}, (json) => membersResponseSchema.parse(json));
}

export async function inviteMembers(emails: string[], role: FirmRole): Promise<InviteOutcome[]> {
  const res = await apiRequest("/v1/firm/invites", { method: "POST", body: { emails, role } }, (json) =>
    inviteResponseSchema.parse(json),
  );
  return res.results;
}

export async function resendInvite(id: string): Promise<void> {
  await apiRequest(`/v1/firm/invites/${encodeURIComponent(id)}/resend`, { method: "POST" });
}

export async function revokeInvite(id: string): Promise<void> {
  await apiRequest(`/v1/firm/invites/${encodeURIComponent(id)}/revoke`, { method: "POST" });
}

export async function changeRole(userId: string, role: FirmRole): Promise<void> {
  await apiRequest(`/v1/firm/members/${encodeURIComponent(userId)}`, { method: "PATCH", body: { role } });
}

export async function removeMember(userId: string): Promise<void> {
  await apiRequest(`/v1/firm/members/${encodeURIComponent(userId)}/remove`, { method: "POST" });
}

/** A pasted list: one invite per address, split on commas, semicolons and whitespace. */
export function parseEmailList(text: string): string[] {
  const out: string[] = [];
  for (const part of text.split(/[\s,;]+/)) {
    const email = part.trim().replace(/^<|>$/g, "").toLowerCase();
    if (email && out.indexOf(email) === -1) out.push(email);
  }
  return out;
}
